// extracted by mini-css-extract-plugin
export default {"root":"IDS7BdnwL8Ilc8bbHbOQ","tableRow":"wXzZUYeC0J5PiPESfAJD","placeHolderShimmer":"j795VA9r707xVFKzq87a"};